var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"border":"2px solid blue"}},[_c('wujie-vue',{ref:"wujieRef",attrs:{"name":"vue3-editor","url":_vm.editorUrl,"sync":true,"alive":true,"exec":true,"props":_vm.editorProps}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }